import { render, staticRenderFns } from "./monthlyRatingTab.vue?vue&type=template&id=cb16cef4&lang=pug"
import script from "./monthlyRatingTab.vue?vue&type=script&lang=js"
export * from "./monthlyRatingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports